import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { Ionicons } from '@expo/vector-icons';
import { RootStackParamList } from '../types/navigation';
import { colors } from '../utils/colors';
import { typography } from '../utils/typography';
import { spacing } from '../utils/theme';

type NavigationProp = NativeStackNavigationProp<RootStackParamList>;

export const SettingsScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp>();

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>設定</Text>
      </View>

      <ScrollView>
        {/* アカウントセクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>アカウント</Text>

          <TouchableOpacity
            style={styles.option}
            onPress={() => navigation.navigate('AccountSettings' as any)}
          >
            <View style={styles.optionLeft}>
              <Ionicons
                name="person-outline"
                size={22}
                color={colors.textSecondary}
              />
              <Text style={styles.optionLabel}>アカウント設定</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        </View>

        {/* 設定カテゴリセクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>設定</Text>

          <TouchableOpacity
            style={styles.option}
            onPress={() => navigation.navigate('NotificationSettings' as any)}
          >
            <View style={styles.optionLeft}>
              <Ionicons
                name="notifications-outline"
                size={22}
                color={colors.textSecondary}
              />
              <Text style={styles.optionLabel}>通知設定</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.option}
            onPress={() => navigation.navigate('DisplaySettings' as any)}
          >
            <View style={styles.optionLeft}>
              <Ionicons
                name="color-palette-outline"
                size={22}
                color={colors.textSecondary}
              />
              <Text style={styles.optionLabel}>表示設定</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.option}
            onPress={() => navigation.navigate('PrivacySettings' as any)}
          >
            <View style={styles.optionLeft}>
              <Ionicons
                name="lock-closed-outline"
                size={22}
                color={colors.textSecondary}
              />
              <Text style={styles.optionLabel}>プライバシー設定</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        </View>

        {/* コンテンツ管理セクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>コンテンツ</Text>

          <TouchableOpacity
            style={styles.option}
            onPress={() => navigation.navigate('Lists' as any)}
          >
            <View style={styles.optionLeft}>
              <Ionicons
                name="list-outline"
                size={22}
                color={colors.textSecondary}
              />
              <Text style={styles.optionLabel}>リスト</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        </View>

        {/* その他セクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>その他</Text>

          <TouchableOpacity
            style={styles.option}
            onPress={() => navigation.navigate('About' as any)}
          >
            <View style={styles.optionLeft}>
              <Ionicons
                name="information-circle-outline"
                size={22}
                color={colors.textSecondary}
              />
              <Text style={styles.optionLabel}>アプリについて</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  header: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    backgroundColor: colors.background,
  },
  headerTitle: {
    ...typography.h2,
    color: colors.text,
  },
  section: {
    marginTop: spacing.lg,
    paddingHorizontal: spacing.md,
  },
  sectionTitle: {
    ...typography.h4,
    color: colors.textSecondary,
    marginBottom: spacing.sm,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  optionLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  optionLabel: {
    ...typography.body,
    color: colors.text,
    marginLeft: spacing.md,
  },
  optionValue: {
    ...typography.body,
    color: colors.textSecondary,
  },
});
